import { shouldRequireBillingAccess } from "./billingAccess";

const TECHNICIAN_ONLY_PATH_PREFIXES = [
  "/technician/schedule",
  "/technician/setup",
  "/technician/profile",
];

export function getEllyannaAuthenticatedLandingPath({ role = "", user = null } = {}) {
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  if (normalizedRole === "technician") {
    return "/technician/schedule";
  }
  if (Boolean(user?.is_super_admin) && !user?.salon_id) {
    return "/superadmin";
  }
  return "/manager/schedule";
}

export function getEllyannaPostSalonSwitchPath({
  pathname = "",
  search = "",
  role = "",
  user = null,
} = {}) {
  const normalizedPath = String(pathname || "");
  const normalizedSearch = String(search || "");
  const currentPath = `${normalizedPath}${normalizedSearch}`;
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  const switchedToTechnician = normalizedRole === "technician";
  const switchedToManagerFamily =
    ["admin", "host", "owner", "manager", "receptionist", "solo_technician", "reception"].includes(
      normalizedRole
    ) || Boolean(user?.is_super_admin);

  const onTechnicianOnlyRoute = TECHNICIAN_ONLY_PATH_PREFIXES.some((prefix) =>
    normalizedPath.startsWith(prefix)
  );
  const onManagerOnlyRoute =
    normalizedPath.startsWith("/manager/") || normalizedPath === "/setup";

  if (
    (onTechnicianOnlyRoute && switchedToManagerFamily) ||
    (onManagerOnlyRoute && switchedToTechnician)
  ) {
    return "/my-salons";
  }

  if (normalizedPath.startsWith("/manager/manage/billing")) {
    if (shouldRequireBillingAccess(normalizedRole, user)) {
      return currentPath;
    }
    const nextPath = new URLSearchParams(normalizedSearch).get("next");
    if (nextPath && nextPath.startsWith("/")) {
      return nextPath;
    }
    return getEllyannaAuthenticatedLandingPath({ role: normalizedRole, user });
  }

  return currentPath;
}
